/**
 * Leaving a game in progress, on purpose only.
 *
 * Two guards already stand on this door and neither one sees a click on the
 * brand: `beforeunload` catches a reload or a closed tab, and the `popstate`
 * block swallows swipe-back and the hardware back button. The brand is a plain
 * router `<Link>` — no unload, no history pop — so a single mis-aimed tap on
 * the logo used to drop a player straight out of a live round, which is the
 * accident the other two exist to prevent.
 *
 * Leaving is still only navigation: the server holds the seat for
 * `settings.reconnectTime`, so coming straight back costs nothing. The prompt
 * says so rather than threatening, because it is a confirmation and not a
 * warning.
 */
export const LEAVE_PROMPT_KEY = 'game.leavePrompt';

/**
 * A lobby is not a game yet and a finished one is not a game any more — asking
 * in either is nagging about nothing. Everything between them is a live round
 * somebody else may be waiting on.
 */
export function shouldConfirmLeave(phase) {
  return phase !== 'LOBBY' && phase !== 'GAME_OVER';
}
